import { Cartesian3, Cartographic, Color, ConstantPositionProperty, ConstantProperty, JulianDate, PolylineOutlineMaterialProperty, CallbackProperty, Math as CesiumMath, } from "cesium";
import { getDefaultFlatGroundEdgeSettings, getDefaultPointToPointPMISettings, } from "../settings/earthbrain-site-settings";
import { FlatGroundOperation, } from "../site/flatground/earthbrain-flatground";
import { AssetType, CESIUM_PICKABLE_ENTITY } from "../types";
import { EarthBrainUtils } from "./earthbrainutility";
import { getEarcutTriangulation } from "./extra-utils";
import { AxisHelper } from "./axis-helper";
import { AABBHelper } from "./aabb-helper";
export class Preview {
    // Entities for Preivew
    _previewSphere;
    _spherePosition;
    _previewLine;
    _previewLinePMI;
    _previewFlatGround;
    _previewFlatGroundEditOutline;
    _previewFlatGroundCenterArrow;
    _previewFlatGroundCenterArrowPosition;
    // private _midPointMap: Map<string, Entity>;
    _previewSphereIdToArrowMap;
    // private _previewArrowPos: Cartesian3[];
    // ToDo: Remove this variable
    _viewer;
    _previewVerticalLine;
    _previewArrowRenderStatus = false;
    _previewCenterArrowRenderStatus = false;
    _axisHelper;
    _aabbHelper;
    constructor(viewer, roadsettings) {
        this._previewSphere = EarthBrainUtils.addSphere(viewer, new Cartesian3(0, 0, 0), Color.RED.withAlpha(0.5));
        this._spherePosition = new Cartesian3(0, 0, 0);
        this._previewSphere.addProperty("allowPicking");
        this._previewSphere["allowPicking"] = false;
        this._previewLine = EarthBrainUtils.createLineEntity(viewer, "roadpreviewline", [], roadsettings.commonSetting.path.polyLineSettings);
        this._previewLinePMI = EarthBrainUtils.createLineEntity(viewer, "pmipreviewline", [], getDefaultPointToPointPMISettings());
        this._previewFlatGround = undefined;
        this._previewFlatGroundEditOutline = EarthBrainUtils.createLineEntity(viewer, CESIUM_PICKABLE_ENTITY.FLAT_GROUND_EDIT_OUTLINE, [], getDefaultFlatGroundEdgeSettings());
        // this._midPointMap = new Map();
        this._previewSphereIdToArrowMap = new Map();
        // this._previewArrowPos = [];
        this._viewer = viewer;
        this._previewVerticalLine = undefined;
        this._axisHelper = new AxisHelper(viewer);
        this._aabbHelper = new AABBHelper(viewer);
    }
    set previewArrowRenderStatus(val) {
        this._previewArrowRenderStatus = val;
    }
    set previewCenterArrowRenderStatus(val) {
        this._previewCenterArrowRenderStatus = val;
    }
    setPreviewFlatGroundCenterArrow(val) {
        this._previewFlatGroundCenterArrow = val;
    }
    getPreviewFlatGroundCenterArrow() {
        return this._previewFlatGroundCenterArrow;
    }
    setPreviewFlatGroundCenterArrowPositon(val) {
        this._previewFlatGroundCenterArrowPosition = val;
    }
    getPreviewFlatGroundCenterArrowPosition() {
        return this._previewFlatGroundCenterArrowPosition;
    }
    isValidPreviewFlatGroundEditOutline(id) {
        return this._previewFlatGroundEditOutline.id === id;
    }
    setSphereVisibility(visible) {
        this._previewSphere.show = visible;
    }
    setSphereColor(color) {
        this._previewSphere.point.color = new ConstantProperty(color);
    }
    resetSphereColor() {
        this._previewSphere.point.color = new ConstantProperty(Color.RED.withAlpha(0.5));
    }
    setLineVisibility(visible) {
        this._previewLine.show = visible;
        !visible && this.setLinePosition([]);
    }
    setPMILineVisibility(visible) {
        this._previewLinePMI.show = visible;
        !visible && this.setPMILinePosition([]);
    }
    isPreviewLineVisible() {
        return this._previewLine.show ? true : false;
    }
    setSpherePosition(position) {
        this._previewSphere.position = new ConstantPositionProperty(position);
        this._spherePosition = position;
        this._viewer.scene.requestRender();
    }
    getSherePosition() {
        return this._spherePosition.clone();
    }
    getSphereEntity() {
        return this._previewSphere;
    }
    setLinePosition(positions) {
        this._previewLine.polyline.positions = new ConstantProperty(positions);
        // this._viewer.scene.requestRender();
    }
    setPMILinePosition(positions) {
        this._previewLinePMI.polyline.positions = new ConstantProperty(positions);
        // this._viewer.scene.requestRender();
    }
    /**
     * updates the preview of the flatground using flatground points
     * @param flatground
     */
    updateFlatGroundPreview(flatground) {
        const flatGroundPoints = flatground._pointsForFlatGround.map((p) => p.position);
        //remove old preview primitive{this._previewFlatGround}
        this._previewFlatGround &&
            this._viewer.scene.primitives.remove(this._previewFlatGround);
        this._previewFlatGround = undefined;
        //get interpolated points{previewPointsForFlatGround} and required geometry
        if (flatGroundPoints.length > 2) {
            const previewPointsForFlatGround = flatground.getInterpolatedPointsForPreview(flatGroundPoints);
            const { faces } = getEarcutTriangulation(previewPointsForFlatGround);
            const geom = {
                indices: faces,
                vertices: Cartesian3.packArray(previewPointsForFlatGround),
            };
            //get and add new preview primitive{this._previewFlatGround}
            this._previewFlatGround = EarthBrainUtils.createEntityFromIndexedGeometry(geom, Color.WHITE.withAlpha(0.4));
            this._viewer.scene.primitives.add(this._previewFlatGround);
        }
    }
    updateFlatGroundPreviewEntity(flatGroundUnderConstrction, cartesian, mode, clickedFlatGroundPointID) {
        if (mode === FlatGroundOperation.FINISH) {
            if (this._previewFlatGround) {
                this._previewFlatGround.show = false;
                this._previewFlatGround = undefined;
            }
            this.setOutlinePreviewOnFlatGroundEdit();
        }
        else if (mode === FlatGroundOperation.CREATION) {
            this._previewFlatGround &&
                this._viewer.scene.primitives.remove(this._previewFlatGround);
            this._previewFlatGround = undefined;
            const previewPointsForFlatGround = this._pointsForFlatGroundPreviewEntity(cartesian.clone(), clickedFlatGroundPointID, mode, flatGroundUnderConstrction);
            this.setOutlinePreviewOnFlatGroundEdit(previewPointsForFlatGround);
            //vertices
            const { faces } = getEarcutTriangulation(previewPointsForFlatGround);
            const geom = {
                indices: faces,
                vertices: Cartesian3.packArray(previewPointsForFlatGround),
            };
            this._previewFlatGround = EarthBrainUtils.createEntityFromIndexedGeometry(geom, Color.WHITE.withAlpha(0.4));
            this._viewer.scene.primitives.add(this._previewFlatGround);
        }
        // this._viewer.scene.requestRender();
    }
    disposePreviewFlatGroundEntity() {
        this._viewer.scene.primitives.remove(this._previewFlatGround);
        this._previewFlatGround = undefined;
        this.setOutlinePreviewOnFlatGroundEdit();
    }
    _pointsForFlatGroundPreviewEntity(previewPoint, selectedPointID, oprationType, flatGroundUnderConstrction) {
        let previewPointsForFlatGround = [];
        if (oprationType === FlatGroundOperation.DRAG) {
            const flatGroundControlPoints = flatGroundUnderConstrction.points.map((p) => p.clone());
            const flatGroundSphereKeys = flatGroundUnderConstrction.spheresKey;
            flatGroundSphereKeys.forEach((key, i) => {
                if (key === selectedPointID) {
                    flatGroundControlPoints[i] = previewPoint;
                }
            });
            previewPointsForFlatGround =
                flatGroundUnderConstrction.getInterpolatedPointsForPreview(flatGroundControlPoints);
        }
        else {
            previewPointsForFlatGround =
                flatGroundUnderConstrction.getInterpolatedPointsForPreview(previewPoint);
        }
        return previewPointsForFlatGround;
    }
    setOutlinePreviewOnFlatGroundEdit(positions, settings) {
        if (positions) {
            //@ts-ignore
            this._previewFlatGroundEditOutline.polyline.positions = [
                ...positions,
                positions[0],
            ];
            this._previewFlatGroundEditOutline.show = true;
            if (settings) {
                if (settings.width !== undefined) {
                    this._previewFlatGroundEditOutline.polyline.width =
                        new ConstantProperty(settings.width);
                }
                if (settings.alpha !== undefined) {
                    const oldMaterial = this._previewFlatGroundEditOutline.polyline
                        .material;
                    const color = oldMaterial.color.getValue(JulianDate.now());
                    color.alpha = settings.alpha;
                    this._previewFlatGroundEditOutline.polyline.material =
                        new PolylineOutlineMaterialProperty({
                            color: color,
                            outlineColor: color,
                        });
                }
            }
        }
        else {
            //@ts-ignore
            this._previewFlatGroundEditOutline.polyline.positions = [];
            this._previewFlatGroundEditOutline.show = false;
        }
    }
    // public _midPointPreviewForFlatGround(status: boolean, flatGroundUC: EarthBrainFlatGround, ) {
    //     const pointsForFlatGround: Cartesian3[] = flatGroundUC.points;
    //     if (status) {
    //         for (let iter = 0; iter <= pointsForFlatGround.length - 1; iter++) {
    //             let midPoints: Cartesian3 = new Cartesian3(0, 0, 0);
    //             Cartesian3.add(pointsForFlatGround[iter % pointsForFlatGround.length], pointsForFlatGround[(iter + 1) % pointsForFlatGround.length], midPoints);
    //             Cartesian3.multiplyByScalar(midPoints, 0.5, midPoints);
    //             const midPointSphereEntity = EarthBrainUtils.createSphere(viewer, midPoints, Color.RED);
    //             this._midPointMap.set(midPointSphereEntity.id, midPointSphereEntity);
    //         }
    //     } else {
    //         this._midPointMap.forEach(point => viewer.entities.remove(point));
    //         this._midPointMap.clear();
    //     }
    //     this._cesiumViewer.scene.requestRender();
    // }
    // public getMidPointEntity(flatGroundPointID: string): Entity {
    //     if (this._midPointMap.has(flatGroundPointID)) {
    //         const data = this._midPointMap.get(flatGroundPointID);
    //         return data;
    //     }
    //     return undefined;
    // }
    // public getMidPointMapKeys(): string[] {
    //     return Array.from(this._midPointMap.keys());
    // }
    /**
     * Arrow Preview function
     * @param flatGroundUC Flat ground enitty under construction
     * @param width Width of arrow
     * @param height Height of arrow
     */
    arrowPreviewForFlatArea(flatGroundUC, width, height) {
        const pointsFlatGroundUC = flatGroundUC.points;
        const keyArray = flatGroundUC.spheresKey;
        // Clear previous arrows
        this.disposeArrowPreviewForFlatArea();
        // Recreate for enabled status
        this._previewArrowRenderStatus &&
            pointsFlatGroundUC.forEach((point, index) => {
                //need to create arrow entity
                // this._previewArrowPos.push(points);
                const startPointOfArrow = pointsFlatGroundUC[index];
                const endPointOfArrowCarto = Cartographic.fromCartesian(startPointOfArrow);
                const endPointOfArrowCarte = Cartesian3.fromRadians(endPointOfArrowCarto.longitude, endPointOfArrowCarto.latitude, endPointOfArrowCarto.height + height);
                const arrowEntityForVerDrag = EarthBrainUtils.createArrow(this._viewer, [startPointOfArrow, endPointOfArrowCarte], width, Color.RED);
                arrowEntityForVerDrag.addProperty("pickInfo"); //Information when this arrow gets picked
                arrowEntityForVerDrag["pickInfo"] = {
                    assetType: AssetType.Flat_Ground_Data,
                    pickableType: CESIUM_PICKABLE_ENTITY.FLAT_GROUND_CONTROL_POINT_ARROW,
                    entity: arrowEntityForVerDrag,
                    owner: flatGroundUC,
                };
                this._previewSphereIdToArrowMap.set(flatGroundUC.getSphereEntity(keyArray[index]).id, {
                    arrow: arrowEntityForVerDrag,
                    position: point,
                });
                // this._previewArrowMap.set(arrowEntityForVerDrag.id, { arrow: arrowEntityForVerDrag, position: point });
            });
        // this._viewer.scene.requestRender();
    }
    disposeArrowPreviewForFlatArea() {
        if (this._previewSphereIdToArrowMap.size > 0) {
            this._previewSphereIdToArrowMap.forEach((val) => this._viewer.entities.remove(val.arrow));
            this._previewSphereIdToArrowMap.clear();
        }
    }
    /**
     * Calculates the center of flatground and creates arrow entity on that position
     * @param flatGround
     * @param width width of arrow
     * @param height height of arrow
     */
    arrowPreviewForFlatGroundCenter(flatGround, width, height) {
        this.disposeFlatGroundCenterArrow();
        if (this._previewCenterArrowRenderStatus) {
            const flatGroundPoints = flatGround.points;
            //calculating center{flatGroundCenter} of the flat ground
            const flatGroundCenter = flatGroundPoints.reduce((sum, point) => Cartesian3.add(sum, point, sum), new Cartesian3());
            Cartesian3.divideByScalar(flatGroundCenter, flatGroundPoints.length, flatGroundCenter);
            const startPointOfArrow = flatGroundCenter.clone();
            const endPointOfArrowCarto = Cartographic.fromCartesian(startPointOfArrow);
            const endPointOfArrow = Cartesian3.fromRadians(endPointOfArrowCarto.longitude, endPointOfArrowCarto.latitude, endPointOfArrowCarto.height + height);
            const positions = [startPointOfArrow, endPointOfArrow];
            const arrowEntity = EarthBrainUtils.createArrow(this._viewer, positions, width, Color.RED);
            arrowEntity.addProperty("pickInfo"); //Information when this arrow gets picked
            arrowEntity["pickInfo"] = {
                assetType: AssetType.Flat_Ground_Data,
                pickableType: CESIUM_PICKABLE_ENTITY.FLAT_GROUND_CENTRAL_ARROW,
                entity: arrowEntity,
                owner: flatGround,
            };
            this.setPreviewFlatGroundCenterArrow(arrowEntity);
            this.setPreviewFlatGroundCenterArrowPositon(startPointOfArrow);
        }
        // this._viewer.scene.requestRender();
    }
    disposeFlatGroundCenterArrow() {
        if (this._previewFlatGroundCenterArrow) {
            this._viewer.entities.remove(this._previewFlatGroundCenterArrow);
            this._previewFlatGroundCenterArrow = undefined;
        }
    }
    getSelectedArrowEntityIndex(arrowEntityID) {
        let requiredIndex = 0;
        const previewArrowPointArray = Array.from(this._previewSphereIdToArrowMap.values());
        previewArrowPointArray.forEach((arrow, index) => {
            if (arrow.arrow.id === arrowEntityID) {
                requiredIndex = index;
            }
        });
        return requiredIndex;
    }
    getArrowEntityPosition(arrowPointID) {
        // let cartesian = new Cartesian3(0, 0, 0);
        // const previewArrowPointIDArray = Array.from(this._previewArrowMap.keys());
        // previewArrowPointIDArray.forEach((id, index) => {
        //     if (id === arrowPointID) {
        //         cartesian = this._previewArrowPos[index];
        //     }
        // });
        // this._cesiumViewer.scene.requestRender();
        // const arrowObj = this._previewSphereIdToArrowMap.get(arrowPointID);
        // return arrowObj ? arrowObj.position : undefined;
        // return cartesian;
        const arrowInfo = Array.from(this._previewSphereIdToArrowMap.values()).find((arrowInfo) => arrowInfo.arrow.id === arrowPointID);
        return arrowInfo ? arrowInfo.position : undefined;
    }
    // public getArrowEntity(arrowPointID: string): Entity {
    //     // if (this._previewArrowMap.has(flatGroundPointID)) {
    //     //     const arrowEntity = this._previewArrowMap.get(flatGroundPointID);
    //     //     return arrowEntity;
    //     // }
    //     const arrowObj = this._previewArrowMap.get(arrowPointID);
    //     return arrowObj ? arrowObj.arrow : undefined;
    //     // return undefined;
    // }
    getArrowEntityFromSphereId(flatGroundPointID) {
        const arrowInfo = this._previewSphereIdToArrowMap.get(flatGroundPointID);
        return arrowInfo ? arrowInfo.arrow : undefined;
    }
    getArrowEntityFromArrowId(arrowId) {
        const arrowInfo = Array.from(this._previewSphereIdToArrowMap.values()).find((arrowInfo) => arrowInfo.arrow.id === arrowId);
        return arrowInfo ? arrowInfo.arrow : undefined;
    }
    setArrowPosition(arrowID, positions) {
        // set position for arrow under edit in MAP
        const arrowUnderEdit = this._previewSphereIdToArrowMap.get(arrowID);
        if (arrowUnderEdit) {
            //@ts-ignore
            arrowUnderEdit.arrow.polyline.positions = positions;
            // const index = this.getSelectedArrowEntityIndex(arrowID);
            // this._previewArrowPos[index] = position[0];
            Cartesian3.clone(positions[0], arrowUnderEdit.position);
        }
        // this._viewer.scene.requestRender();
    }
    getLengthOfArrowMap() {
        return this._previewSphereIdToArrowMap.size;
    }
    disposeArrow() {
        //uniform drag arrow
        this.previewCenterArrowRenderStatus = false;
        this.disposeFlatGroundCenterArrow();
        //switch drag arrows
        this._previewSphereIdToArrowMap.forEach((info) => this._viewer.entities.remove(info.arrow));
        this._previewSphereIdToArrowMap.clear();
    }
    removeArrowEntity(clickedSphereId) {
        const entity = this.getArrowEntityFromSphereId(clickedSphereId);
        this._viewer.entities.remove(entity);
        this._previewSphereIdToArrowMap.delete(clickedSphereId);
    }
    createVerticalLineCallbackProperty(positionSource, offsetHeight) {
        return new CallbackProperty(() => {
            const cartographic = Cartographic.fromCartesian(positionSource());
            const lon = CesiumMath.toDegrees(cartographic.longitude);
            const lat = CesiumMath.toDegrees(cartographic.latitude);
            const height = cartographic.height;
            return Cartesian3.fromDegreesArrayHeights([
                lon,
                lat,
                height - offsetHeight,
                lon,
                lat,
                height + offsetHeight,
            ]);
        }, false);
    }
    createVerticalLineEntityOnSphere({ name = "VerticalLine", width = 2, color = Color.BLUE, outlineColor = Color.BLACK, outlineWidth = 1, clampToGround = false, show = true, } = {}) {
        if (this._previewVerticalLine) {
            this._previewVerticalLine.polyline.positions =
                this.createVerticalLineCallbackProperty(() => this._spherePosition, 1000);
            this._previewVerticalLine.show = show;
        }
        else {
            const callbackProperty = this.createVerticalLineCallbackProperty(() => this._spherePosition, 1000);
            const lineSettings = {
                width,
                color,
                outlineColor,
                outlineWidth,
                clampToGround,
                show,
            };
            const entity = EarthBrainUtils.createLineEntity(this._viewer, name, callbackProperty, lineSettings);
            this._previewVerticalLine = entity;
        }
        this._viewer.scene.requestRender();
    }
    setVerticalLineEntityVisibility(visible) {
        if (this._previewVerticalLine) {
            this._previewVerticalLine.show = visible;
        }
    }
    /**
     * Gets the AxisHelper instance
     */
    get axisHelper() {
        return this._axisHelper;
    }
    /**
     * Gets the AABBHelper instance
     */
    get aabbHelper() {
        return this._aabbHelper;
    }
    // ── Multi-point marker management ──────────────────────────────────
    _multiPointMarkers = [];
    /** Add a marker sphere at the given WGS84 position and return it. */
    addMultiPointMarker(position, color = Color.RED.withAlpha(0.6)) {
        const entity = EarthBrainUtils.addSphere(this._viewer, position, color);
        this._multiPointMarkers.push(entity);
        return entity;
    }
    /** Remove the last added marker (undo). */
    removeLastMultiPointMarker() {
        const entity = this._multiPointMarkers.pop();
        if (entity) {
            try {
                this._viewer.entities.remove(entity);
            }
            catch (e) {
                console.warn("[Preview] failed to remove multi-point marker:", e);
            }
        }
    }
    /** Remove all multi-point markers. */
    clearMultiPointMarkers() {
        for (const entity of this._multiPointMarkers) {
            try {
                this._viewer.entities.remove(entity);
            }
            catch (e) {
                console.warn("[Preview] failed to remove multi-point marker:", e);
            }
        }
        this._multiPointMarkers = [];
    }
}
//# sourceMappingURL=earthbrain-preview.js.map